import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

const styles = {
  container: {
    marginBottom: '24px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: '100%',
    letterSpacing: '0px',
    margin: '0 0 8px 0',
  },
  text: {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '150%',
    letterSpacing: '0px',
    margin: 0,
  },
};

const GENERAL_TEXT =
  'Some credit card transactions may be subject to additional fees or surcharges based on the selected payment method and/or company policies. As the customer, you acknowledge that you are responsible for any applicable fees or surcharges. Debit and prepaid cards are not eligible for surcharging, and the surcharge is not greater than the cost of acceptance.';

const ACTION_TEXT =
  'Some credit card transactions may be subject to additional fees or surcharges based on the selected payment method and/or company policies. By clicking Submit, you acknowledge that you, as the customer, are responsible for any applicable fees or surcharges. Debit and prepaid cards are not eligible for surcharging, and the surcharge is not greater than the cost of acceptance.';

const SurchargeNotice = ({ className, kind, enableSurcharging }) => {
  if (!enableSurcharging) return null;

  const text = kind === 'action' ? ACTION_TEXT : GENERAL_TEXT;

  return (
    <div
      className={classNames('surchargeNotice', className)}
      style={styles.container}
    >
      <p style={styles.title}>Surcharge Notice</p>
      <p style={styles.text}>{text}</p>
    </div>
  );
};

const mapStateToProps = (state) => {
  const location = state.locations.location;
  return {
    enableSurcharging: location?.enableSurcharging ?? false,
  };
};

export default connect(mapStateToProps)(SurchargeNotice);
